<section class="sponsored-wrapper">
  <div class="sponsor-item" [ngClass]="{
    'sponsor-item__left-position': isTooltipInLeftPosition && !isHeroBanner,
    'sponsor-item__right-position': !isTooltipInLeftPosition && !isHeroBanner,
    'sponsor-item__left-position-hero-banner': isTooltipInLeftPosition && isHeroBanner,
    'sponsor-item__right-position-hero-banner': !isTooltipInLeftPosition && isHeroBanner}"
  >
    <app-sponsoring-tooltip
      *ngIf="isWrappedComponentVisible$ | async"
      [position]="sponsorItem.position"
      [isMobile]="isMobile$ | async"
      (onTooltipClick)="triggerTooltipClickEvent()"
      (onTooltipHover)="triggerTooltipHoverEvent()"
    >
      <ng-container *ngTemplateOutlet="infoContent"></ng-container>
    </app-sponsoring-tooltip>
  </div>
  <ng-content></ng-content>
</section>

<app-sponsoring-overlay *ngIf="overlayOpen$ | async" [isMobile]="isMobile$ | async" (closeSidebar)="hideOverlay()">
  <section class="overlay">
    <ng-container *ngTemplateOutlet="infoContent"></ng-container>
  </section>
</app-sponsoring-overlay>

<ng-template #infoContent>
  <div>
    <p class="sponsor-item__section-title">
      {{ 'HOME.HOME_PAGE.SPONSORED.WHY_I_SEE_THIS_AD.QUESTION.TEXT' | translate }}
    </p>
    <p class="sponsor-item__section-text">
      {{ 'HOME.HOME_PAGE.SPONSORED.WHY_I_SEE_THIS_AD.ANSWER.TEXT' | translate }}
    </p>
  </div>

  <div>
    <p class="sponsor-item__section-title">
      {{ 'HOME.HOME_PAGE.SPONSORED.ABOUT_ADVERTISER.TITLE.TEXT' | translate }}
    </p>
    <p class="sponsor-item__section-text">
      {{ 'HOME.HOME_PAGE.SPONSORED.ADVERTISER_NAME.TEXT' | translate }}
      <span class="sponsor-item__section-info">{{ sponsorItem?.advertiserName }}</span>
    </p>
    <p class="sponsor-item__section-text">
      {{ 'HOME.HOME_PAGE.SPONSORED.ADVERTISER_PAYER_NAME.TEXT' | translate }}
      <span class="sponsor-item__section-info">
        {{ sponsorItem?.advertiserPayerName }}
      </span>
    </p>
  </div>
</ng-template>
